"use client";

import { Button } from "@/components/ui/button";
import { authClient } from "@/lib/auth-client";

export function Navbar() {
	const { data: session } = authClient.useSession();

	return (
		<nav className="animate-fade-up relative z-10 flex items-center justify-between px-6 py-5 md:px-12">
			<div className="flex items-center gap-2">
				<div className="flex h-8 w-8 items-center justify-center rounded-md bg-indigo-500">
					<span className="font-sans text-lg font-semibold text-white">u</span>
				</div>
				<span className="font-mono text-sm tracking-tight text-foreground/80">unranked</span>
			</div>
			<div className="flex items-center gap-4">
				<a
					href="/tools/audit"
					className="font-mono text-xs tracking-wide text-muted-foreground transition-colors hover:text-foreground"
				>
					Tools
				</a>
				<a
					href="/blog"
					className="font-mono text-xs tracking-wide text-muted-foreground transition-colors hover:text-foreground"
				>
					Blog
				</a>
				<a
					href="#pricing"
					className="font-mono text-xs tracking-wide text-muted-foreground transition-colors hover:text-foreground"
				>
					Pricing
				</a>
				{session ? (
					<a href="/dashboard">
						<Button
							size="sm"
							className="bg-indigo-500 font-mono text-xs tracking-wide text-white hover:bg-indigo-400"
						>
							Dashboard
						</Button>
					</a>
				) : (
					<>
						<a
							href="/sign-in"
							className="font-mono text-xs tracking-wide text-muted-foreground transition-colors hover:text-foreground"
						>
							Sign in
						</a>
						<a href="/sign-up?plan=lite">
							<Button
								size="sm"
								className="bg-indigo-500 font-mono text-xs tracking-wide text-white hover:bg-indigo-400"
							>
								Start tracking
							</Button>
						</a>
					</>
				)}
			</div>
		</nav>
	);
}
